import React from "react";
import { TouchableOpacity } from "react-native";
import { graphql } from "react-relay";
import { useFragment } from "react-relay/hooks";
import NotificationBadge from "@components/atoms/NotificationBadge";
import { navigate } from "@navigation/navigate";
import type { NotificationBell_total$key as NotificationBellTotalKey } from "@generated/NotificationBell_total.graphql";

const totalFragment = graphql`
  fragment NotificationBell_total on NotificationUnreadTotal {
    count
  }
`;

type Props = {
  fragmentRef: NotificationBellTotalKey;
};

export default function NotificationBell({ fragmentRef }: Props): JSX.Element {
  const { count } = useFragment(totalFragment, fragmentRef);
  return (
    <TouchableOpacity
      accessibilityLabel="お知らせ"
      accessibilityRole="button"
      hitSlop={{ top: 8, right: 8, bottom: 8, left: 8 }}
      onPress={() => navigate("Notifications")}
    >
      <NotificationBadge count={count ?? 0} size={24} />
    </TouchableOpacity>
  );
}
